import {Injectable} from "@angular/core";
import {NestApiProvider} from "../nest-api";
import {Observable} from "rxjs";

@Injectable()
export class ApiWorkLocation {
  private _service: string = 'setting';
  private _model: string = 'workLocation';

  constructor(
    private nestApiProvider: NestApiProvider
  ) {

  }

  findWorkLocation(): Observable<any>{
    const _method: string = 'GET';
    const _func: string = 'findWorkLocation';
    const _params: any = {};
    const _urlParams: any = {};
    const _body: any = {};
    const _url = this.nestApiProvider.urlBuilder(_method, this._model, _func, {}, {}, this._service);
    return this.nestApiProvider.request(_method, _url, _params, _urlParams, _body);
  }

  findOneWorkLocation(body: any):Observable<any>{
    const _method: string = 'POST';
    const _func: string = 'findOneWorkLocation';
    const _params: any = {
      worklocationCode: body
    };
    const _urlParams: any = {};
    const _body: any = {};
    const _url = this.nestApiProvider.urlBuilder(_method, this._model, _func, {}, {}, this._service);
    return this.nestApiProvider.request(_method, _url, _params, _urlParams, _body);
  }

  public createWorkLocation(body: any): Observable<any> {
    const _method: string = 'POST';
    const _func: string = 'createWorkLocation';
    const _params: any = {
      worklocationName: body.worklocationName,
      worklocationAddress: body.worklocationAddress,
      latLng: body.latLng,
      maxRadius: body.maxRadius,
      phone: body.phone,
      fax: body.fax
    };
    const _urlParams: any = {};
    const _body: any = {};
    const _url = this.nestApiProvider.urlBuilder(_method, this._model, _func, {}, {}, this._service);
    return this.nestApiProvider.request(_method, _url, _params, _urlParams, _body);
  }

  updateWorkLocation(body: any): Observable<any> {
    const _method: string = 'POST';
    const _func: string = 'updateWorkLocation';
    const _params: any = {
      worklocationCode: body.worklocationCode,
      worklocationName: body.worklocationName,
      worklocationAddress: body.worklocationAddress,
      latLng: body.latLng,
      maxRadius: body.maxRadius,
      phone: body.phone,
      fax: body.fax
    };
    const _urlParams: any = {};
    const _body: any = {};
    const _url = this.nestApiProvider.urlBuilder(_method, this._model, _func, {}, {}, this._service);
    return this.nestApiProvider.request(_method, _url, _params, _urlParams, _body);
  }

  deleteWorkLocation(body: any): Observable<any> {
    const _method: string = 'POST';
    const _func: string = 'deleteWorkLocation';
    const _params: any = {
      worklocationCode: body.worklocationCode
    };
    const _urlParams: any = {};
    const _body: any = {};
    const _url = this.nestApiProvider.urlBuilder(_method, this._model, _func, {}, {}, this._service);
    return this.nestApiProvider.request(_method, _url, _params, _urlParams, _body);
  }


}



// WEBPACK FOOTER //
// ./src/shared/nestjs/work-location/work-location.ts